import styled from 'styled-components';
import Barcode from 'react-barcode';
import moment from 'moment';
import { Col, Row } from 'react-bootstrap';

import fnbLogo from '~/src/static/img/fnb.png';
import backgroundLine from '~/src/static/img/BackgroundLine.png';
import { DATE_FORMAT } from '~/src/utils/constants';
import { FnbItemGetDto, FnbOrderGetWithItemsDto } from 'svila-common';

interface Props {
  item: FnbOrderGetWithItemsDto;
  isLast: boolean;
}

export default function PrintSingleConsolidation({ item, isLast }: Props): JSX.Element {
  return (
    <div>
      <Wrapper style={{ display: 'block' }}>
        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Content style={{ marginTop: 5 }}>
            <Logo src={fnbLogo} alt="fnbLogo" />
          </Content>
          <Content style={{ display: 'flex', flexDirection: 'column' }}>
            <Barcode value={item.uniqueNumber} height={40} width={3} flat={true} />
          </Content>
          <Content style={{ textAlign: 'right', marginTop: 5 }}>
            <span>FnB FOOD AND BEVERAGE</span>
            <span>КАФЕ И СЛАДКИ</span>
            <b style={{ textAlign: 'right', color: '#FF3155' }}>www.fnb.bg</b>
          </Content>
        </Box>
        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Content>
            <GreyText>ПОЛУЧАТЕЛ:</GreyText>
            <Text>
              Име:{' '}
              <b>
                {item.shName} {item.shNameLast}
              </b>
            </Text>
            <Text>
              Адрес: <b>{item.shAddress}</b>
            </Text>
            <Text>
              Град: <b>{item.shCityName}</b>
            </Text>
            <Text>
              Държава: <b>България</b>
            </Text>
            <Text>
              Телефон: <b>{item.phone}</b>
            </Text>
          </Content>
          <Content style={{ justifyContent: 'space-between' }}>
            <Text style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>Дата:</span> <b>{item ? moment(item.orderDate).format(DATE_FORMAT) : null}</b>
            </Text>
            <div>
              <Text style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
                Общо продукти: <b style={{ fontSize: 20 }}>{item.totalBase} лв.</b>
              </Text>
              <Text style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                Доставка: <b>{item.shipmentCost} лв.</b>
              </Text>
              <Text style={{ display: 'flex', justifyContent: 'space-between' }}>
                Обща стойност: <b style={{ fontSize: 20 }}>{item.total} лв.</b>
              </Text>
            </div>
          </Content>
          <Content style={{ alignItems: 'flex-end' }}>
            <GreyText>ИЗПРАЩАЧ:</GreyText>
            <Text>
              Име: <b>БОНО ФАЙН ФУУДС ЕООД</b>
            </Text>
            <Text>
              ЕИК: <b>201483575</b>
            </Text>
            <Text>
              Адрес: <b>пл. Градска болница № 1,</b>
            </Text>
            <Text>
              <b>ет. 3, офис 10</b>
            </Text>
            <Text>
              Град: <b>Хасково</b>
            </Text>
            <Text>
              Телефон: <b>+359 89 7066399</b>
            </Text>
          </Content>
        </Box>
        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Content>
            <div>
              <GreyText>Избран метод за плащане:</GreyText>
              <br />
              <Text>
                <b>{item.paymentMethodTxt}</b>
              </Text>
            </div>
          </Content>
          <Content>
            <div>
              <GreyText>Статус:</GreyText>
              <br />
              <Text>
                <b>{item.paymentInfo ? item.paymentInfo : 'Няма данни за извършено плащане'}</b>
              </Text>
            </div>
          </Content>
          <Content style={{ alignItems: 'flex-end' }}>
            <div>
              <GreyText>Начин за доставка:</GreyText>
              <br />
              <Text>
                <b>{item.shippingName}</b>
              </Text>
            </div>
          </Content>
        </Box>
        <div>
          <BackgroundLine src={backgroundLine} alt="backgroundLine" />
        </div>
        <TableStyle>
          <TheadStyle>
            <tr>
              <th>
                <GreyText>ПРОДУКТИ</GreyText>
              </th>
              <th style={{ textAlign: 'right' }}>
                <GreyText>ЕДИНИЧНА ЦЕНА</GreyText>
              </th>
              <th style={{ textAlign: 'right' }}>
                <GreyText>БРОЙ</GreyText>
              </th>
              <th style={{ textAlign: 'right' }}>
                <GreyText>ЦЕНА</GreyText>
              </th>
            </tr>
          </TheadStyle>
          <TBodyStyles>
            {item?.items?.map((product: FnbItemGetDto) => {
              return (
                <TrStyle>
                  <TdStyle>
                    {product.name}
                    <br></br>
                    <span style={{ fontSize: 18, color: '#999' }}>{product.code}</span>
                  </TdStyle>
                  <TdStyle style={{ textAlign: 'right' }}>{product.price} лв.</TdStyle>
                  <TdStyle style={{ textAlign: 'right' }}>{product.qtty} бр.</TdStyle>
                  <TdStyle style={{ textAlign: 'right', padding: 0 }}>
                    <b>{Math.round(product.price * product.qtty * 100) / 100} лв.</b>
                  </TdStyle>
                </TrStyle>
              );
            })}
          </TBodyStyles>
        </TableStyle>
      </Wrapper>
      {!isLast && <Text style={{ pageBreakBefore: 'always' }}></Text>}
    </div>
  );
}

const Logo = styled.img`
  width: 150px;
  height: 100%;
`;

const TheadStyle = styled.thead`
  border-bottom: 1px solid #eaeaea;
`;

const Wrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

const TableStyle = styled.table`
  width: 100%;
  margin-bottom: 20px;
  padding-bottom: 50px;
  &tr:nth-child(odd) {
    background-color: #eee;
  }
  &tr:nth-child(even) {
    background-color: #fff;
  }
`;

const GreyText = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #999;
`;

const Text = styled.p`
  font-size: 16px;
  margin: 0;
`;

const TdStyle = styled.td`
  font-size: 16px;
  padding: 10px;
`;

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 11px 12px;
  flex: 1;
`;

const Box = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TrStyle = styled.tr`
  border-bottom: 1px solid #eaeaea;
`;

const TBodyStyles = styled.tbody`
  // ${TrStyle}:nth-child(even) {
  //   background: #eee;
  // }
`;

const BackgroundLine = styled.img`
  width: 100%;
  margin: 30px 0;
`;
